export default "__VITE_ASSET__DhIjG4mC__"